module.exports = __webpack_public_path__ + "static/media/travel-plaza.aa535cfc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dealerFeatures/travel-plaza.svg
// module id = 2551
// module chunks = 2